import { gql } from '@apollo/client'

export const COMPLETE_SIGNUP_NUDGE_PHONE_MUTATION = gql`
  mutation CompleteSignupNudgePhone($input: EditProfilePhoneInput!) {
    editProfilePhone(input: $input) {
      profile {
        id
        mainPhone {
          phone
        }
      }
    }
  }
`
